import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ToastReusable } from '../../../../libs/core/shared/ui/toast-reusable/toast-reusable';

@Component({
  imports: [RouterModule, ToastReusable],
  selector: 'app-root',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  protected title = 'portal';
}
